/**
 * Classe utilitaire pour afficher le pdf
 */
export default class PdfUtils {
  /**
   * Affiche le pdf reçu dans un nouvel onglet
   * @param inoAnswer Réponse du serveur
   * @return {Promise<unknown>} L'url du stream
   */
  static async showPDF(inoAnswer) {
    return new Promise((resolve) => {
      // Pour IE et Edge
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        const oPdf = new Blob([inoAnswer.data], { type: 'application/pdf' });
        window.navigator.msSaveOrOpenBlob(oPdf);
        return resolve(oPdf);
      }
      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const oPdf = new Blob([inoAnswer.data], { type: 'octet/stream' });
      const oData = window.URL.createObjectURL(oPdf);
      const oLink = document.createElement('a');

      oLink.href = oData;
      oLink.download = `Formulaire-prelevement-IS${Date.now()}.pdf`;
      document.body.appendChild(oLink);
      oLink.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        document.body.removeChild(oLink);
        window.URL.revokeObjectURL(oData);
      }, 1000);
      return resolve(oPdf);
    });
  }
}
